import cx from 'classnames'

import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ReactComponent as LeftArrowIcon } from 'assets/icons/arrowLeft24.svg'
import { GhostButton } from 'components/Buttons/GhostButton'
import { SUPPORT_EMAIL } from 'utils/constants'
import { DemoCard } from '../LinkCards/DemoCard'
import RightPanelContent from '../RightPanelContent/RightPanelContent'
import ProgressBar from '../ProgressBar/ProgressBar'
import Shared from '../../Shared.module.scss'
import Styles from './WaitingList.module.scss'

interface WaitingListProps {
  totalSteps: number
  transitionPage: (page: string) => void
}
export const WaitingList = ({ totalSteps, transitionPage }: WaitingListProps) => {
  const { isTabletPortrait } = useResponsiveDesign()

  const goBack = () => {
    transitionPage('GO_BACK')
  }

  return (
    <div className={Shared.content}>
      <div className={Shared.leftPanel}>
        <div className={Shared.header}>
          <GhostButton className={Shared.backButton} aria-label="Back" onClick={goBack}>
            <LeftArrowIcon />
          </GhostButton>
          <ProgressBar totalSteps={totalSteps} currentStep={totalSteps} />
        </div>

        <div className={cx(Shared.largerLeftContent, Styles.largerLeftContent)}>
          <div>
            <div className={Shared.title}>You’re on the waitlist</div>
            <div className={cx(Shared.subTitle, Styles.subTitle)}>
              Our team will reach out once a spot opens on our waitlist.
            </div>
            <DemoCard transitionPage={transitionPage} />
          </div>
          <div className={Styles.helpText}>
            Need help?{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className={Styles.contactUsLink}>
              Contact Us
            </a>
          </div>
        </div>
      </div>
      {!isTabletPortrait && <RightPanelContent screen="demoScheduled" />}
    </div>
  )
}
